import { flow, types } from 'mobx-state-tree'
import { getProcessingEntity } from '../../network/getProcessingEntity'
import { getErrorMessage, MessageTypes } from '../../utils'
import { RootStore } from '../store'

const Merchant = types.model('Merchant', {
  id: types.optional(types.string, ''),
  merchantId: types.optional(types.string, ''),
  mappingStatus: types.optional(types.string, ''),
  ledgerAcctNumber: types.optional(types.string, ''),
})

const LedgerMapping = types
  .model('LedgerMapping', {
    merchant: types.optional(Merchant, {}),
    merchants: types.array(Merchant),
  })
  .actions((self) => ({
    getAll: flow(function* getAll() {
      try {
        // change this afer getting apis
        const response = yield getProcessingEntity(RootStore.session.getTokens)
        const own = self
        own.merchants = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getMappingList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.merchants ??[]
      const data = listData?.map((item) => {
        return {
          ID: '' + item?.id,
          merchantId: item?.merchantId,
          ledgerAcctNumber: item?.ledgerAcctNumber,
          mappingStatus: item?.mappingStatus,
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return listData.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      } else {
        return data
      }
    },
    getMerchant(isEdit: boolean) {
      const item = self.merchant
      const data = {
        merchantId: item?.merchantId ?? '',
        ledgerAcctNumber: item?.ledgerAcctNumber,
        mappingStatus: isEdit ? item?.mappingStatus?.slice(0, -1) ?? '' : item?.mappingStatus ?? '',
      }
      return data
    },
  }))

const ledgerMappingData = LedgerMapping.create({
  merchant: {
    id: '1',
    merchantId: '1000100012012',
    mappingStatus: 'Active',
    ledgerAcctNumber: '3411334234',
  },
  merchants: [
    {
      id: '1',
      merchantId: '1000100012012',
      mappingStatus: 'Active',
      ledgerAcctNumber: '3411334234',
    },
    {
      id: '2',
      merchantId: '1000100012013',
      mappingStatus: 'Inactive',
      ledgerAcctNumber: '4411334234',
    },
  ],
})

export { LedgerMapping, Merchant, ledgerMappingData }
